import { jsx } from 'react/jsx-runtime';
import State from './State.js';

/**
 * Elemento dello Stepper.
 */
const Step = function Step({ className, code, icon, onClick, optional, state, title, subTitle, }) {
    return (jsx("div", { children: JSON.stringify({
            className, code, icon, onClick, optional, state, title, subTitle,
        }) }));
};
Step.State = State;
Step.defaultProps = {
    className: '',
    code: null,
    icon: null,
    onClick: null,
    optional: false,
    subTitle: null,
};

export { Step as default };
